export const i18nNameSpace = {
  COMMON: 'common',
  CAMPAIGNS: 'campaigns',
  USERS: 'users',
  API: 'api',
} as const;

export type I18nNameSpaces = typeof i18nNameSpace;
